import React from 'react';

const Problems = () => {
  const problems = [
    {
      icon: "ri-file-excel-2-line",
      problem: "Manual processes that waste time",
      description: "Still tracking orders, inventory, or customer data in Excel and WhatsApp? Losing hours to manual data entry and updates?"
    },
    {
      icon: "ri-error-warning-line",
      problem: "Errors due to disconnected systems",
      description: "Data errors, missed orders, and communication gaps because your sales, delivery, and operations aren't connected?"
    },
    {
      icon: "ri-eye-off-line",
      problem: "No visibility into business performance",
      description: "Can't track growth metrics, customer trends, or operational efficiency because data is scattered across multiple tools?"
    },
    {
      icon: "ri-links-line",
      problem: "Sales, delivery, operations not connected",
      description: "Teams working in silos with no unified system, leading to delays, confusion, and poor customer experience?"
    }
  ];

  return (
    <section id="problems" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Problems Your Business Faces</h2>
          <div className="w-20 h-1 bg-primary mx-auto mb-8"></div>
          <p className="max-w-3xl mx-auto text-lg text-gray-700">
            These common bottlenecks slow down growth and cost you money. We build systems that solve them.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {problems.map((item, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-lg border-l-4 border-red-500 hover:shadow-md transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} ri-xl text-red-600`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{item.problem}</h3>
                  <p className="text-gray-700">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-block bg-primary/10 px-8 py-4 rounded-lg">
            <p className="text-lg font-semibold text-gray-900">
              <i className="ri-arrow-right-line text-primary mr-2"></i>
              We turn these problems into automated, efficient systems that save time and reduce costs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problems;
